// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3nOxQ","calendarButtons":"ClockData_calendarButtons__3VxFV"};